module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFAgMAAAABCpX7AAAAAXNSR0IB2cksfwAAAAlQTFRFAAAAAAAAAAAAg2PpwAAAAAN0Uk5TAGD/solA9AAAABxJREFUeJxjyFo1gUFqlQMD20oGBsYlDAwMAQwANuMETfBvwZ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/drop-down.png
// module id = 811
// module chunks = 0